<template>
    <div class="codelab-button-group">
        <ul :class="['func-list', direction]">
            <li 
            class="func-item" 
            v-for="func in funcs"
            :key="func.title" 
            @click="quickEdit(func.fn)"
            :title="$t(func.title)"
            >
                <svg-icon :href="func.href" :width="25" :height="25"></svg-icon>
            </li>
        </ul>
    </div>
</template>
<script>
const Blockly = window.Blockly;
export default {
    name: "button-group",
    props: {
        direction: {
            type: String,
            default: "horizontal"
        },
        funcs: Array
    },
    methods: {
        quickEdit(key){
            Blockly.WidgetDiv.hide();
            this.$root.$emit(key);
        }
    }
}
</script>
<style lang="scss">
    .codelab-button-group{
        .func-list{
            width: 100%;
            height: 100%;
            overflow: hidden;
            &.horizontal{
                width: 100%;
                height: 42px;
                white-space: nowrap;
                .func-item{
                    margin-left: 15px;
                    &:first-child{
                        margin-left: 0;
                    }
                }
            }
            &.vertical{
                width: 42px;
                height: 100%;
                .func-item{
                    margin-top: 15px;
                    &:first-child{
                        margin-top: 0;
                    }
                }
            }
            .func-item{
                display: inline-block;
                width: 42px;
                height: 42px;
                line-height: 42px;
                font-size: 0;
                text-align: center;
                
                border-radius: 21px;
                background: #333333;
                cursor: pointer;

                svg{
                    fill: #a8a8ac;
                    stroke: #a8a8ac;
                }
                &:hover,&:active{
                    svg{
                        fill: #0ED3FF;
                        stroke: #0ED3FF;
                    }
                }
            }
        }
    }
</style>